import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

/**
 * RevolvingBadge — circular text spinning around a central icon.
 * Uses SVG textPath so the text hugs the circle. Click routes to contact.
 */
const RevolvingBadge = ({ text = 'BOOK A CALL · HYPELAB · ', size = 160, onClick }) => {
  const radius = size / 2 - 12;
  const pathId = 'revolving-path';
  return (
    <motion.button
      onClick={onClick}
      data-testid="revolving-badge"
      data-cursor-label="Click"
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.95 }}
      transition={{ type: 'spring', damping: 12, stiffness: 200 }}
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <motion.svg
        viewBox={`0 0 ${size} ${size}`}
        width={size}
        height={size}
        animate={{ rotate: 360 }}
        transition={{ duration: 18, ease: 'linear', repeat: Infinity }}
        className="absolute inset-0"
      >
        <defs>
          <path
            id={pathId}
            d={`M ${size / 2},${size / 2} m -${radius},0 a ${radius},${radius} 0 1,1 ${radius * 2},0 a ${radius},${radius} 0 1,1 -${radius * 2},0`}
          />
        </defs>
        <text
          fill="currentColor"
          className="text-[#1C1917]"
          style={{ fontSize: 12, letterSpacing: '0.22em', fontWeight: 700 }}
        >
          <textPath href={`#${pathId}`}>{text.repeat(3)}</textPath>
        </text>
      </motion.svg>

      {/* Center dot */}
      <span className="relative w-14 h-14 rounded-full bg-[#AA94FF] flex items-center justify-center shadow-lg">
        <ArrowUpRight className="w-6 h-6 text-[#F4F4F3]" />
      </span>
    </motion.button>
  );
};

export default RevolvingBadge;
